module.exports = __webpack_public_path__ + "images/category_lp/smartphone/assessment_achievements/4_ddaf7c7faaa8244fa6527bc1d4d265bf.jpg";